import { connect } from 'react-redux';

import Preview from 'carbon-react/lib/components/preview';

const PreviewComponent = () => {
  return (
    <div className="timesheet">
      <div className="top-bar">
        <Preview height="40px" width="100%" loading />
      </div>
      <div className="timesheet-content">
        <div className="clusters-wrapper" style={{ width: 379 }}>
          <Preview height="100%" loading />
        </div>
        <div className="main-content">
          <div className="top-components" style={{ height: 104 }}>
            <Preview height="100%" loading />
          </div>
          <Preview height="100%" loading />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataSources: state.dataSources,
});

export default connect(mapStateToProps, null)(PreviewComponent);
